import { getConfig as getConfigService } from "config/service/config-service";

export const getConfig = () => async (dispatch) => {
    const res = await getConfigService();
    dispatch({ type: "CONFIG_LOAD", payload: res });
};